<template>
  <div class="app flex-row align-items-center">
    <div class="container">


      <div class="row justify-content-center">
        <div class="card-group mb-0" v-if="control">
          <div class="card p-2" style="width: 350px; height: 350px">
            <div class="card-header text-center" style="background-color: black;">
              <img src="static/img/logo.png" style="height: 47px; width: 175px"/>
            </div>
            <div class="">
              <br/>
              <hr style="margin-top: -2px; margin-bottom: 25px">

              <div class="input-group mb-1">
                <span class="input-group-addon"><i class="icon-user"></i></span>
                <input type="email" class="form-control" placeholder="Email" v-model="email">
              </div>
              <div class="input-group mb-2">
                <span class="input-group-addon"><i class="icon-lock"></i></span>
                <input type="password" class="form-control" v-on:keyup.enter="login" placeholder="Password"
                       v-model="password">
              </div>

              <div class="row">
                <div class="col-6">
                  <button type="button" class="btn btn-primary px-2" @click="login">Login</button>
                </div>
              </div>
            </div>
          </div>
        </div>
        <h1 v-if="control==false">{{cabal}}</h1>
      </div>
    </div>
  </div>
</template>

<script>
  import trans_cat from '../translates/cat/CabalTemp';
  import trans_es from '../translates/es/CabalTemp';
  import constants from '../constants'
  import middleware from "../utilities/middlewares";

  export default {
    name: 'Login',
    data() {
      return {
        web_texts: '',
        email: '',
        password: '',
        control: true,
        cabal: "S/D"
      }
    },
    created() {
      this.email = window.localStorage.getItem('email');
      this.password = window.localStorage.getItem('password');
      this.web_texts=middleware.selectTranslation(trans_cat,trans_es);
    },
    mounted() {

    },
    methods: {
      login() {
        var out = this;
        axios.post(constants.OAUTH_SERVER_URL, {
          grant_type: constants.OAUTH_GRANT_TYPE,
          client_id: constants.OAUTH_CLIENT_ID,
          client_secret: constants.OAUTH_CLIENT_SECRET,
          username: out.email,
          password: out.password,
          scope: ''
        }).then(function (res) {
          var token = res.data.access_token;
          axios.defaults.headers.common['Authorization'] = 'Bearer ' + token;
          window.localStorage.setItem(constants.STORAGE_TOKEN_KEY, token);
          console.log(token);
          out.control=false;

          out.getRealTimeEventsGenerator();
          setInterval(function () {
              out.getRealTimeEventsGenerator();
          }, 5000);

        }).catch(function (err) {
          out.email = '';
          out.password = '';
          console.log(err.message);
        })
      },
      getRealTimeEventsGenerator() {
        axios.post(constants.ROOT_URL + '/api/v1/real_time_value_master', {
          system_id: 14,
          client_device: 'd',
          vars: '[["' + 50 + '", "R$CAL_Cabal.CABAL"]]'
        }).then((response) => {
          this.cabal=Math.round(response.data.value*100)/100;
        }, (response) => {
          console.log(response)
        });
      },
    }
  }
</script>
<style scoped>

</style>



// WEBPACK FOOTER //
// CabalTemp.vue?3a851a3a